const COMPONENT_EVENTS = {
  Load: {
    description: 'Triggered when user loads page',
    eventHub: {
      code: 'LOAD',
      action: 'Page loaded'
    },
    ga: {
      action: 'Page loaded'
    }
  },
  Logout: {
    description: 'Triggered when user logs out',
    eventHub: {
      code: 'LOGOUT',
      action: 'Clicked logout'
    },
    ga: {
      action: 'Clicked logout'
    }
  },
  Continue: {
    description: 'Triggered when user continues',
    eventHub: {
      code: 'CONTINUE',
      action: 'Clicked continue'
    },
    ga: {
      action: 'Clicked continue'
    }
  },
  Save: {
    description: 'Triggered when user saves screen data',
    eventHub: {
      code: 'SAVE',
      action: 'Clicked save and continue'
    },
    ga: {
      action: 'Clicked save and continue'
    }
  },
  OpenedWhyAsk: {
    description: 'Triggered when why do we ask dialogue is shown',
    eventHub: {
      code: 'OPENEDWHYASK',
      action: 'Clicked why do we ask this'
    }
  },
  OpenedWhyNeed: {
    description: 'Triggered when why do we ask dialogue is shown',
    eventHub: {
      code: 'OPENEDWHYNEED',
      action: 'Clicked why do you need this'
    }
  },
  PolicyMe: {
    description: 'Triggered when user redirects to PolicyMe',
    eventHub: {
      code: 'POLICYME',
      action: 'Clicked PolicyMe'
    },
    ga: {
      action: 'Clicked PolicyMe'
    }
  },
  Willful: {
    description: 'Triggered when user redirects to Willful',
    eventHub: {
      code: 'WILLFUL',
      action: 'Clicked Willful'
    },
    ga: {
      action: 'Clicked Willful'
    }
  },
  Youthfully: {
    description: 'Triggered when user redirects to Youthfully',
    eventHub: {
      code: 'YOUTHFULLY',
      action: 'Clicked Youthfully'
    },
    ga: {
      action: 'Clicked Youthfully'
    }
  },
  Contribution: {
    description: 'Triggered when user redirects to contribution',
    eventHub: {
      code: 'CONTRIBUTION',
      action: 'Clicked make a contribution'
    },
    ga: {
      action: 'Clicked make a contribution'
    }
  },
  Dashboard: {
    description: 'Triggered when user redirects to dashboard',
    eventHub: {
      code: 'DASHBOARD',
      action: 'Clicked go to dashboard'
    },
    ga: {
      action: 'Clicked go to dashboard'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`]
    .filter((str) => !!str)
    .join('_');
};

module.exports = {
  onboardingApplicationComponentEvents: {
    CosubscriberRelationship: {
      code: 'COSUBRELATIONSHIP',
      events: {
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'CosubscriberRelationship'
            ),
            dataKeys: ['relationship']
          }
        },
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Load.eventHub.action,
              'CosubscriberRelationship'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Load.ga.action,
              'CosubscriberRelationship'
            )
          }
        }
      }
    },
    PlanType: {
      code: 'PLANTYPE',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'PlanType'
            ),
            dataKeys: ['appType']
          }
        },
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Load.eventHub.action,
              'PlanType'
            ),
            categoryOverride: {
              NUF: null,
              CSON: null
            }
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'PlanType'
            ),
            dataKeys: ['planType']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'PlanType'
            ),
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'PlanType'
            ),
            dataKeys: ['planType'],
            categoryOverride: {
              ADDPLAN: {
                code: 'GETPLAN',
                action: createEventAction('Clicked get plan', 'PlanType')
              }
            }
          }
        }
      }
    },
    ChildDetails: {
      code: 'CHILDDETAILS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'ChildDetails'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'ChildDetails'
            ),
            dataKeys: ['beneficiaries']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'ChildDetails'
            ),
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'ChildDetails'
            ),
            dataKeys: ['beneficiaries']
          }
        },
        FirstName: {
          description: 'Triggered when user triggers event on first name field',
          eventHub: {
            code: 'FIRSTNAME',
            action: 'ChildProfile_Child first name [$.action]',
            dataKeys: ['firstName'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        LastName: {
          description: 'Triggered when user triggers event on last name field',
          eventHub: {
            code: 'LASTNAME',
            action: 'ChildProfile_Child last name [$.action]',
            dataKeys: ['lastName'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        BirthDay: {
          description: 'Triggered when user triggers event on birth day field',
          eventHub: {
            code: 'BIRTHDAY',
            action: 'ChildProfile_DOB day [$.action]',
            dataKeys: ['birthDay'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        BirthMonth: {
          description:
            'Triggered when user triggers event on birth month field',
          eventHub: {
            code: 'BIRTHMONTH',
            action: 'ChildProfile_DOB month [$.action]',
            dataKeys: ['birthMonth'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        BirthYear: {
          description: 'Triggered when user triggers event on birth year field',
          eventHub: {
            code: 'BIRTHYEAR',
            action: 'ChildProfile_DOB year [$.action]',
            dataKeys: ['birthYear'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        Relationship: {
          description:
            'Triggered when user triggers event on relationship field',
          eventHub: {
            code: 'RELATIONSHIP',
            action: 'ChildProfile_Relationship drop-down [$.action]',
            dataKeys: ['relationship'],
            categoryOverride: {
              ADDBENE: null,
              ADDPLAN: null
            }
          }
        },
        AddChild: {
          description: 'Triggered when user adds a child to plan',
          eventHub: {
            code: 'ADDCHILD',
            action: 'Add a child to plan'
          }
        },
        Reminder: {
          description: 'Triggered set a reminder child profile',
          eventHub: {
            code: 'REMINDER',
            action: 'ChildProfile_Clicked set a reminder'
          },
          ga: {
            action: 'ChildProfile_Clicked set a reminder',
            pushToDataLayer: true
          }
        },
        Skip: {
          description: 'Triggered skip child information',
          eventHub: {
            code: 'SKIP',
            action: 'ChildProfile_Clicked skip for now'
          }
        },
        BeneAddressCheckbox: {
          description:
            'Triggered when user triggers event on address checkbox field',
          eventHub: {
            code: 'BENEADDRESS',
            action: 'ChildProfile_Address checkbox [$.action]',
            dataKeys: ['isChecked'],
            categoryOverride: {
              ADDBENE: {
                action: 'ChildProfile_Clicked address checkbox',
                dataKeys: null
              },
              ADDPLAN: null
            }
          }
        }
      }
    },
    SetReminder: {
      code: 'SETREMINDER',
      events: {
        Click: {
          description: 'Set reminder - reminder set',
          eventHub: {
            code: 'CLICK',
            action: 'SetReminder_ReminderSet'
          },
          ga: {
            action: 'SetAReminder_Clicked set a reminder',
            pushToDataLayer: true
          }
        }
      }
    },
    Calculation: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Calculation'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'ProjectedSavings'
            ),
            dataKeys: ['childAge', 'contribution', 'province']
          }
        },
        UpdateChildAge: {
          description: 'Triggered when child age is updated on calculator',
          eventHub: {
            code: 'UPDATECHILDAGE',
            action: 'ProjectedSavings_Changed child age'
          }
        },
        UpdateMonthlyContribution: {
          description: 'Triggered when user updates monthly contributions',
          eventHub: {
            code: 'UPDATEMONTHCONTRIBUTION',
            action: 'ProjectedSavings_Changed monthly contribution'
          }
        },
        UpdateProvince: {
          description: 'Triggered when user updates monthly contributions',
          eventHub: {
            code: 'UPDATEPROVINCE',
            action: 'ProjectedSavings_Changed province'
          }
        }
      }
    },
    FreePromotion: {
      code: 'KYCPREEMPT',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'FreePromotion'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'KYCPreempt'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'KYCPreempt'
            ),
            pushToDataLayer: true
          }
        }
      }
    },
    EmploymentAndMarital: {
      code: 'EMPLOYMENTANDMARITAL',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'EmploymentAndMarital'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'EmploymentAndMarital'
            ),
            dataKeys: [
              'maritalStatus',
              'employmentStatus',
              'statusDescription',
              'jobTitle'
            ]
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'EmploymentAndMarital'
            )
          }
        }
      }
    },
    IncomeAndDependents: {
      code: 'INCOMEANDDEPENDENTS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IncomeAndDependents'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'IncomeAndDependents'
            ),
            dataKeys: ['annualIncome', 'dependents']
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'IncomeAndDependents'
            )
          }
        }
      }
    },
    AlmostThere: {
      code: 'KYCPREEMPT2',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'AlmostThere'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'KYCPreempt2'
            )
          },
          ga: {
            categoryOverride: {
              CSON: {
                action: createEventAction(
                  COMPONENT_EVENTS.Save.ga.action,
                  'KYCPreempt2'
                )
              }
            },
            pushToDataLayer: true
          }
        },
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Load.eventHub.action,
              'KYCPreempt2'
            )
          }
        }
      }
    },
    LiabilitiesAndAssets: {
      code: 'LIABILITIESANDASSETS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'AssetsAndLiabilities'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'AssetsAndLiabilities'
            ),
            dataKeys: ['assetAmount', 'liabilitiesAmount']
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'AssetsAndLiabilities'
            )
          }
        }
      }
    },
    InvestmentExperience: {
      code: 'INVESTEXP',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'InvestmentExperience'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'InvestingExperience'
            ),
            dataKeys: ['investingExperience', 'investingExperienceDescription']
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'InvestingExperience'
            )
          }
        }
      }
    },
    IPSQuestions: {
      code: 'IPS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IPSQuestions'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'IPSQuestions'
            ),
            dataKeys: ['ipsQuestionResponses']
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'IPSQuestions_[$.questionName]'
            ),
            dataKeys: ['ipsQuestionResponses'],
            categoryOverride: {
              NUF: null,
              CSON: null
            }
          }
        }
      }
    },
    RiskProfile: {
      code: 'RISK',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'RiskProfile'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'RiskProfile'
            ),
            dataKeys: ['isLowRiskProfileScore', 'riskProfileScore']
          },
          ga: {
            action: 'RiskScore_Clicked save and continue',
            pushToDataLayer: true
          }
        },
        RedoQuestionnaire: {
          description: 'Triggered when user goes into redo questionnaire flow',
          eventHub: {
            code: 'REDO',
            action: 'RiskScoreConservative_Clicked redo questionnaire'
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'RiskProfile'
            )
          }
        }
      }
    },
    ConservativePlanNotice: {
      code: 'CONSERVATIVE',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'ConservativePlanNotice'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: 'Triggered when user accepts conservative plan notice',
          eventHub: {
            code: 'ACCEPT',
            action: 'ConversativeAcknowledgement_Clicked I accept',
            dataKeys: ['isConservativeNoticeAccepted']
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'ConversativeAcknowledgement'
            ),
            dataKeys: ['isConservativeNoticeAccepted'],
            categoryOverride: {
              ADDPLAN: {
                code: 'ACCEPT',
                action: 'ConversativeAcknowledgement_Clicked I accept'
              }
            }
          }
        },
        RedoQuestionnaire: {
          description: 'Triggered when user goes into redo questionnaire flow',
          eventHub: {
            code: 'REDO',
            action: 'ConversativeAcknowledgement_Clicked redo questionnaire'
          }
        }
      }
    },
    Grants: {
      code: 'GRANT',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Grants'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'Grants'
            ),
            dataKeys: ['province', 'eligibleGrants']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'Grants'
            ),
            pushToDataLayer: true
          }
        },
        UpdateProvince: {
          description: 'Triggered when user updates province',
          eventHub: {
            code: 'PROVINCE',
            action: 'GovernmentGrants_Selected Province'
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'Grants'
            ),
            dataKeys: ['province', 'eligibleGrants']
          }
        }
      }
    },
    IDVGateway: {
      code: 'IDVGateway',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IDVGateway'
            ),
            dataKeys: ['appType']
          }
        },
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Load.eventHub.action,
              'IDVGateway'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Load.ga.action,
              'IDVGateway'
            ),
            pushToDataLayer: true
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'IDVGateway'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'IDVGateway'
            ),
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'IDVGateway'
            )
          }
        },
        Click: {
          description: 'Triggered when user clicks on IDV FAQ link',
          eventHub: {
            code: 'CLICK',
            action: createEventAction('Clicked IDV FAQ', 'IDVGateway')
          }
        }
      }
    },
    IDVerification: {
      code: 'IDVERIFICATION',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IDVerification'
            ),
            dataKeys: ['appType']
          }
        },
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Load.eventHub.action,
              'IDVerification'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Load.ga.action,
              'IDVerification'
            ),
            pushToDataLayer: true
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'IDVerification'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'IDVerification'
            ),
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'IDVerification'
            )
          }
        },
        Success: {
          eventHub: {
            code: 'SUCCESS',
            action: 'IDVerification_IDVSuccess',
            dataKeys: ['jobId']
          },
          ga: {
            action: 'IDVerification_IDVSuccess',
            pushToDataLayer: true
          }
        },
        Failure: {
          eventHub: {
            code: 'FAILURE',
            action: 'IDVerification_IDVFailure',
            dataKeys: ['jobId', 'errors', 'entered', 'identification']
          },
          ga: {
            action: 'IDVerification_IDVFailure',
            pushToDataLayer: true
          }
        },
        Retry: {
          eventHub: {
            code: 'RETRY',
            action: 'IDVRetry'
          },
          ga: {
            action: 'IDVerification_IDVRetry',
            pushToDataLayer: true
          }
        }
      }
    },
    SubscriberInfo: {
      code: 'SUBSCRIBER',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'SubscriberInfo'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'SubscriberInfo'
            ),
            dataKeys: ['firstName', 'lastName', 'dob', 'phone', 'address']
          },
          ga: {
            action: 'SubscriberInformation_Clicked save and continue',
            pushToDataLayer: true
          }
        }
      }
    },
    SubscriberSIN: {
      code: 'SUBSIN',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'SubscriberSIN'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'SubscriberSIN'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'SubscriberSIN'
            ),
            pushToDataLayer: true
          }
        },
        OpenedWhyNeed: {
          description: 'Triggered when why do we ask dialogue is shown',
          eventHub: {
            code: 'WHYNEEDOPENED',
            action: 'SubscriberSIN_Clicked why do you need this'
          }
        }
      }
    },
    BeneficiarySIN: {
      code: 'BENESIN',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'BeneficiarySIN'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'BeneficiarySIN'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'BeneficiarySIN'
            ),
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'BeneficiarySIN'
            )
          }
        },
        OpenedWhyNeed: {
          description: 'Triggered when why do we ask dialogue is shown',
          eventHub: {
            code: 'WHYNEEDOPENED',
            action: 'BeneficiarySIN_Clicked why do you need this'
          }
        },
        RedirectGetSIN: {
          description: 'Triggered when user is redirected to how to get a SIN',
          eventHub: {
            code: 'REDIRECTGETSIN',
            action: 'BeneficiarySIN_Clicked how to get a SIN'
          }
        },
        Reminder: {
          description: 'Triggered set a reminder on beneficiary SIN',
          eventHub: {
            code: 'REMINDER',
            action: 'BeneficiarySIN_Clicked set a reminder'
          },
          ga: {
            action: 'BeneficiarySIN_Clicked set a reminder',
            pushToDataLayer: true
          }
        },
        Skip: {
          description: 'Triggered skip beneficiry SIN',
          eventHub: {
            code: 'SKIP',
            action: 'BeneficiarySIN_Clicked skip for now'
          },
          ga: {
            action: 'BeneficiarySIN_Clicked skip for now',
            pushToDataLayer: true
          }
        }
      }
    },
    ApplicationReview: {
      code: 'PRIMARYAPPREVIEW',
      events: {
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'PrimaryApplicationReview'
            ),
            dataKeys: ['promoCode']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Save.ga.action,
              'PrimaryApplicationReview'
            ),
            categoryOverride: {
              CSON: null
            },
            pushToDataLayer: true
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Continue.eventHub.action,
              'PrimaryApplicationReview'
            )
          }
        },
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'PrimaryApplicationReview'
            ),
            dataKeys: ['appType']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Logout.ga.action,
              'PrimaryApplicationReview'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        Edit: {
          description: 'Triggered when user edits a question',
          eventHub: {
            code: 'EDIT',
            action: 'PrimaryApplicationReview_Clicked edit [$.screenName]'
          }
        }
      }
    },
    TermsAndConditions: {
      code: 'TERMS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'TermsAndConditions'
            ),
            dataKeys: ['appType']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Logout.ga.action,
              'TermsAndConditions'
            ),
            categoryOverride: {
              CSON: null
            },
            pushToDataLayer: true
          }
        },
        Submit: {
          description: 'Triggered when onboarding is submitted',
          eventHub: {
            code: 'SUBMIT',
            previousEventCode: 'ONBD-33',
            action: 'TermsAndConditions_Clicked submit application',
            categoryOverride: {
              CSON: {
                previousEventCode: null
              },
              ADDPLAN: {
                previousEventCode: null
              }
            }
          },
          ga: {
            action: 'TermsAndConditions_Clicked submit application',
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        Decline: {
          description: 'Triggered when declines terms and conditions',
          eventHub: {
            code: 'DECLINE',
            previousEventCode: 'ON_Decline',
            action: 'TermsAndConditions_Clicked decline',
            categoryOverride: {
              CSON: {
                previousEventCode: null
              },
              ADDPLAN: {
                previousEventCode: null
              }
            }
          },
          ga: {
            action: 'TermsAndConditions_Clicked decline',
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        Error: {
          description:
            'Triggered when there is an error during application submit process',
          eventHub: {
            code: 'ERROR',
            action: createEventAction('Submit_Error', 'TermsAndConditions'),
            dataKeys: ['errors'],
            categoryOverride: {
              CSON: null,
              ADDPLAN: null,
              ADDBENE: null
            }
          }
        }
      }
    },
    // Should remove if CosubOnboardingSuccess page is renamed to Success in ScreenFlow
    CosubOnboardingSuccess: {
      code: 'SUCCESS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'YourAllSetSuccess'
            )
          }
        },
        Load: {
          description: 'Triggered when onboarding is loaded',
          eventHub: {
            code: 'COMPLETE',
            action: 'Co-sub Onboarded Successfully'
          },
          ga: {
            action: 'Co-sub Onboarded Successfully'
          }
        }
      }
    },
    Success: {
      code: 'SUCCESS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'YourAllSetSuccess'
            ),
            dataKeys: ['appType']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Logout.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        AddMoney: {
          description: 'Triggers when add money is clicked',
          eventHub: {
            code: 'ADDMONEY',
            action: 'Success_Clicked add money'
          }
        },
        Done: {
          description: 'Triggers when done is clicked',
          eventHub: {
            code: 'DONE',
            action: 'Success_Clicked done'
          }
        },
        PolicyMe: {
          description: COMPONENT_EVENTS.PolicyMe.description,
          eventHub: {
            code: COMPONENT_EVENTS.PolicyMe.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.PolicyMe.eventHub.action,
              'YourAllSetSuccess'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.PolicyMe.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            }
          }
        },
        Willful: {
          description: COMPONENT_EVENTS.Willful.description,
          eventHub: {
            code: COMPONENT_EVENTS.Willful.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Willful.eventHub.action,
              'YourAllSetSuccess'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Willful.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            }
          }
        },
        Youthfully: {
          description: COMPONENT_EVENTS.Youthfully.description,
          eventHub: {
            code: COMPONENT_EVENTS.Youthfully.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Youthfully.eventHub.action,
              'YourAllSetSuccess'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Youthfully.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            }
          }
        },
        Dashboard: {
          description: COMPONENT_EVENTS.Dashboard.description,
          eventHub: {
            code: COMPONENT_EVENTS.Dashboard.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Dashboard.eventHub.action,
              'YourAllSetSuccess'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Dashboard.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              CSON: null,
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        Contribution: {
          description: COMPONENT_EVENTS.Contribution.description,
          eventHub: {
            code: COMPONENT_EVENTS.Contribution.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Contribution.eventHub.action,
              'YourAllSetSuccess'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Contribution.ga.action,
              'YourAllSetSuccess'
            ),
            categoryOverride: {
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        },
        Load: {
          description: 'Triggered when onboarding is loaded',
          eventHub: {
            code: 'COMPLETE',
            action: COMPONENT_EVENTS.Load.eventHub.action,
            categoryOverride: {
              NUF: {
                action: 'Onboarding - RESP Open Success'
              },
              CSON: {
                action: 'Co-sub Onboarded Successfully'
              },
              ADDPLAN: null
            }
          },
          ga: {
            action: COMPONENT_EVENTS.Load.ga.action,
            categoryOverride: {
              NUF: {
                action: 'Onboarding - RESP Open Success'
              },
              CSON: {
                action: 'Co-sub Onboarded Successfully'
              },
              ADDPLAN: null
            },
            pushToDataLayer: true
          }
        }
      }
    },
    UnderReview: {
      code: 'UNDERREVIEW',
      events: {
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: 'Onboarding_RESP Open_Under review',
            categoryOverride: {
              CSON: null,
              ADDPLAN: null,
              ADDBENE: null
            }
          }
        },
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'YourAllSetUnderReview'
            ),
            dataKeys: ['appType']
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Logout.ga.action,
              'YourAllSetUnderReview'
            ),
            categoryOverride: {
              CSON: null
            },
            pushToDataLayer: true
          }
        },
        PolicyMe: {
          description: COMPONENT_EVENTS.PolicyMe.description,
          eventHub: {
            code: COMPONENT_EVENTS.PolicyMe.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.PolicyMe.eventHub.action,
              'YourAllSetUnderReview'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.PolicyMe.ga.action,
              'YourAllSetUnderReview'
            ),
            categoryOverride: {
              CSON: null
            }
          }
        },
        Willful: {
          description: COMPONENT_EVENTS.Willful.description,
          eventHub: {
            code: COMPONENT_EVENTS.Willful.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Willful.eventHub.action,
              'YourAllSetUnderReview'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Willful.ga.action,
              'YourAllSetUnderReview'
            ),
            categoryOverride: {
              CSON: null
            }
          }
        },
        Youthfully: {
          description: COMPONENT_EVENTS.Youthfully.description,
          eventHub: {
            code: COMPONENT_EVENTS.Youthfully.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Youthfully.eventHub.action,
              'YourAllSetUnderReview'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Youthfully.ga.action,
              'YourAllSetUnderReview'
            ),
            categoryOverride: {
              CSON: null
            }
          }
        },
        Dashboard: {
          description: COMPONENT_EVENTS.Dashboard.description,
          eventHub: {
            code: COMPONENT_EVENTS.Dashboard.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Dashboard.eventHub.action,
              'YourAllSetUnderReview'
            )
          },
          ga: {
            action: createEventAction(
              COMPONENT_EVENTS.Dashboard.ga.action,
              'YourAllSetUnderReview'
            ),
            categoryOverride: {
              CSON: null
            },
            pushToDataLayer: true
          }
        }
      }
    },
    CannotContinue: {
      code: 'CANNOTCONTINUE',
      events: {
        Load: {
          description: 'Triggered when cannot continue dialog was loaded',
          eventHub: {
            code: 'CANNOTCONTINUE',
            action: 'YouCantContinueDigitally_Page load'
          }
        }
      }
    }
  }
};
